import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { GiftActivateApiInputs, GiftPurchaseAcceptInfo } from 'frontend/types/premium/gifts';
import { postData } from 'frontend/utils/ajax';
import { apiResolve } from 'frontend/router';

interface GiftPurchaseAcceptState {
  giftPurchaseInfo: GiftPurchaseAcceptInfo;
}

const giftPurchaseAccept: Module<GiftPurchaseAcceptState, RootState> = {
  namespaced: true,
  state: {} as GiftPurchaseAcceptState,

  mutations: {
    setValue(state: GiftPurchaseAcceptState, value: GiftPurchaseAcceptInfo): void {
      state.giftPurchaseInfo = value;
    },
  },

  actions: {
    async activateGift({}, inputs: GiftActivateApiInputs): Promise<boolean> {
      const url = apiResolve({ name: 'gift_purchase_activate_api' }).href;
      try {
        const response = await postData(url, inputs);
        return response.results.gift_purchase_activate_success.value === true;
      } catch (_) {
        return false;
      }
    },
  },
};

export default giftPurchaseAccept;
